<template>
  <span>+</span>
</template>
